import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title max-sm-w-100" }
const _hoisted_4 = { class: "d-flex align-items-center position-relative my-1 max-sm-w-100" }
const _hoisted_5 = { class: "svg-icon svg-icon-1 position-absolute ms-4" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "card-toolbar max-sm-w-100" }
const _hoisted_8 = {
  class: "d-flex flex-wrap gap-3 justify-content-end max-sm-w-100",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_9 = {
  type: "button",
  class: "btn btn-light-primary",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_order_request_filter_drown"
}
const _hoisted_10 = { class: "svg-icon svg-icon-2" }
const _hoisted_11 = {
  type: "button",
  class: "btn btn-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end"
}
const _hoisted_12 = { class: "svg-icon svg-icon-2" }
const _hoisted_13 = {
  key: 1,
  class: "me-0"
}
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_16 = {
  key: 1,
  class: "bi bi-three-dots fs-3"
}
const _hoisted_17 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary w-250px fw-bold",
  "data-kt-menu": "true"
}
const _hoisted_18 = { class: "menu-item px-3" }
const _hoisted_19 = { class: "menu-content fs-6 text-dark fw-bolder px-3 py-4" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_21 = { class: "menu-item px-3" }
const _hoisted_22 = [":class"]
const _hoisted_23 = { class: "menu-item px-3" }
const _hoisted_24 = [":class"]
const _hoisted_25 = { class: "menu-item px-3" }
const _hoisted_26 = { class: "menu-content fs-6 text-dark fw-bolder px-3 py-4" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_28 = { class: "menu-item px-3" }
const _hoisted_29 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_30 = { class: "menu-item px-3" }
const _hoisted_31 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3 opacity-75" }, null, -1)
const _hoisted_33 = { class: "card-body pt-0 vip-table" }
const _hoisted_34 = { class: "text-nowrap" }
const _hoisted_35 = { class: "mw-150px fs-7 text-gray-400 text-line-clamp-1" }
const _hoisted_36 = { class: "text-nowrap" }
const _hoisted_37 = { class: "fs-7 text-gray-400" }
const _hoisted_38 = { class: "w-100" }
const _hoisted_39 = { class: "d-flex align-items-center" }
const _hoisted_40 = { class: "svg-icon me-1" }
const _hoisted_41 = { class: "text-nowrap" }
const _hoisted_42 = { class: "text-nowrap" }
const _hoisted_43 = { class: "text-nowrap" }
const _hoisted_44 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_window_resize = _resolveComponent("window-resize")!
  const _component_FilterDropdown = _resolveComponent("FilterDropdown")!
  const _component_permission_common = _resolveComponent("permission-common")!
  const _component_OrderRequestV2Item = _resolveComponent("OrderRequestV2Item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_MBDatatablePlus = _resolveComponent("MBDatatablePlus")!
  const _component_import_modal = _resolveComponent("import-modal")!
  const _directive_auth = _resolveDirective("auth")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen021.svg" })
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchItems())),
              class: "form-control form-control-solid w-250px ps-14 max-sm-w-100",
              placeholder: _ctx.t('common.search')
            }, null, 40, _hoisted_6), [
              [_vModelText, _ctx.search]
            ]),
            _withDirectives(_createElementVNode("span", {
              class: "svg-icon svg-icon-1 position-absolute top-50 end-0 mr-2 translate-middle",
              style: {"cursor":"pointer"},
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.removeSearch && _ctx.removeSearch(...args)))
            }, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ], 512), [
              [_vShow, _ctx.search != '']
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (_ctx.store.getters.currentUser.user_type === 0)
              ? (_openBlock(), _createBlock(_component_el_select, {
                  key: 0,
                  class: "w-200px",
                  modelValue: _ctx.options.type,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.options.type) = $event)),
                  onChange: _ctx.typeChange
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.typeOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"]))
              : _createCommentVNode("", true),
            _createVNode(_component_window_resize, null, {
              sm: _withCtx(() => [
                _createElementVNode("button", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen031.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("common.filter")), 1)
                ])
              ]),
              lg: _withCtx(() => [
                _createElementVNode("button", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen031.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("common.filter")), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_FilterDropdown, {
              onSubmitFilter: _ctx.handleFilter,
              onResetFilter: _ctx.handleFilterReset
            }, null, 8, ["onSubmitFilter", "onResetFilter"]),
            (!_ctx.isMB)
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("button", {
                    class: "btn btn-icon btn-bg-light btn-active-color-primary",
                    "data-kt-menu-trigger": "click",
                    "data-kt-menu-placement": "bottom-end",
                    "data-kt-menu-flip": "top-end",
                    disabled: 
                _ctx.disabledExportConfirmedTrack ||
                _ctx.disabledExportIncomingShipments ||
                _ctx.loading
              
                  }, [
                    (
                  _ctx.disabledExportConfirmedTrack ||
                  _ctx.disabledExportIncomingShipments
                )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15))
                      : (_openBlock(), _createElementBlock("i", _hoisted_16))
                  ], 8, _hoisted_14),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_permission_common, { role: { auth: ['import'] } }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.t("common.import")), 1)
                        ]),
                        _hoisted_20,
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", {
                            class: "menu-link px-3",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.fileImport(1))),
                            ":class": {
                    disabled: _ctx.loading,
                  },
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#modal_import_order_request",
                            style: {"font-size":"normal"}
                          }, _toDisplayString(_ctx.t("orderRequest.importConfirmedTrack")), 9, _hoisted_22)
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", {
                            class: "menu-link px-3",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.fileImport(2))),
                            ":class": {
                    disabled: _ctx.loading,
                  },
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#modal_import_order_request",
                            style: {"font-size":"normal"}
                          }, _toDisplayString(_ctx.t("orderRequest.importIncomingShipments")), 9, _hoisted_24)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_permission_common, { role: { auth: ['export'] } }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.t("common.export")), 1)
                        ]),
                        _hoisted_27,
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["menu-link px-3", {
                      'opacity-50': _ctx.disabledExportConfirmedTrack || _ctx.loading,
                      'cursor-nodrop': _ctx.disabledExportConfirmedTrack || _ctx.loading,
                    }]),
                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.fileExportConfirmedTrack && _ctx.fileExportConfirmedTrack(...args))),
                            style: {"font-size":"normal"}
                          }, [
                            (_ctx.disabledExportConfirmedTrack && !_ctx.loading)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_29))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(_ctx.t("orderRequest.exportConfirmedTrack")), 1)
                          ], 2)
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["menu-link px-3", {
                      'opacity-50': _ctx.disabledExportIncomingShipments || _ctx.loading,
                      'cursor-nodrop':
                        _ctx.disabledExportIncomingShipments || _ctx.loading,
                    }]),
                            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.fileExportIncomingShipments && _ctx.fileExportIncomingShipments(...args))),
                            style: {"font-size":"normal"}
                          }, [
                            (_ctx.disabledExportIncomingShipments && !_ctx.loading)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_31))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(_ctx.t("orderRequest.exportIncomingShipments")), 1)
                          ], 2)
                        ])
                      ]),
                      _: 1
                    }),
                    _hoisted_32
                  ])
                ])), [
                  [_directive_auth, { auth: ['export', 'import'] }]
                ])
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_33, [
        _createVNode(_component_MBDatatablePlus, {
          class: "max-sm-text-nowrap",
          loading: _ctx.loading,
          "table-data": _ctx.tableData,
          "table-header": _ctx.tableHeader,
          "enable-items-per-page-dropdown": true,
          "current-page": _ctx.currentPage,
          total: _ctx.total,
          "rows-per-page": _ctx.pageSize,
          order: "desc",
          onCurrentChange: _ctx.onCurrentPageChange,
          onItemsPerPageChange: _ctx.onRowsPerPageChange,
          onSort: _ctx.onColumnSort
        }, {
          "cell-sub": _withCtx(({ row: item }) => [
            (_openBlock(), _createBlock(_component_OrderRequestV2Item, {
              key: item.id,
              isExpand: item.isExpand,
              id: item.id
            }, null, 8, ["isExpand", "id"]))
          ]),
          "cell-request_number": _withCtx(({ row: item }) => [
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_router_link, {
                to: 
                _ctx.getMerchantOrderRouterPath(_ctx.$route) + '/' + item.id + '/overview'
              ,
                class: "text-gray-800 text-hover-primary",
                onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.request_number), 1)
                ]),
                _: 2
              }, 1032, ["to"]),
              _createVNode(_component_el_popover, {
                placement: "top",
                width: "auto",
                trigger: "hover"
              }, {
                reference: _withCtx(() => [
                  _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.CommonArrayToString(item.__show.external_order_number)), 1)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(_ctx.CommonArrayToString(item.__show.external_order_number)), 1)
                ]),
                _: 2
              }, 1024)
            ])
          ]),
          "cell-request_date": _withCtx(({ row: item }) => [
            _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.formatDateTime(item.request_date, "YYYY-MM-DD")), 1)
          ]),
          "cell-company": _withCtx(({ row: item }) => [
            _createElementVNode("div", null, [
              _createElementVNode("div", null, _toDisplayString(item.__show.settlement_entity_name), 1)
            ])
          ]),
          "cell-merchant_vendor": _withCtx(({ row: item }) => [
            _createVNode(_component_el_popover, {
              placement: "top",
              width: "auto",
              trigger: "hover"
            }, {
              reference: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("div", null, _toDisplayString(item.__show.channel), 1),
                  _createElementVNode("div", _hoisted_37, _toDisplayString(item.__show.channel_type), 1)
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(item.__show.merchant), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          "cell-representative": _withCtx(({ row: item }) => [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("span", _hoisted_40, [
                  _createVNode(_component_inline_svg_icon, {
                    style: {"width":"36px","height":"36px"},
                    src: "media/icons/duotune/communication/com006.svg"
                  })
                ]),
                _createElementVNode("div", null, _toDisplayString(item.__show.representative.name), 1)
              ])
            ])
          ]),
          "cell-qty": _withCtx(({ row: item }) => [
            _createElementVNode("div", _hoisted_41, _toDisplayString(item.__show.qty), 1)
          ]),
          "cell-total": _withCtx(({ row: item }) => [
            _createElementVNode("div", _hoisted_42, _toDisplayString(item.__show.currency_code == "￥"
                ? _ctx.$currency.currency(
                    item.__show.total_amount,
                    2,
                    ".",
                    "",
                    item.__show.currency_code + " "
                  )
                : _ctx.$currency.currency(
                    item.__show.total_amount,
                    2,
                    ",",
                    ".",
                    item.__show.currency_code + " "
                  )), 1)
          ]),
          "cell-status": _withCtx(({ row: item }) => [
            _createElementVNode("span", {
              class: _normalizeClass(["badge text-uppercase", _ctx.getOrderRequestProgressClass(item.order_progress)])
            }, _toDisplayString(item.__show.order_progress), 3)
          ]),
          "cell-actions": _withCtx(({ row: item }) => [
            _createElementVNode("div", _hoisted_43, [
              _createVNode(_component_router_link, {
                to: 
                _ctx.getMerchantOrderRouterPath(_ctx.$route) + '/' + item.id + '/overview'
              ,
                onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"])),
                class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_44, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                  ])
                ]),
                _: 2
              }, 1032, ["to"])
            ])
          ]),
          _: 1
        }, 8, ["loading", "table-data", "table-header", "current-page", "total", "rows-per-page", "onCurrentChange", "onItemsPerPageChange", "onSort"])
      ])
    ]),
    _createVNode(_component_import_modal, {
      onUpdateList: _ctx.updateList,
      uploadUrl: _ctx.options.uploadUrl
    }, null, 8, ["onUpdateList", "uploadUrl"])
  ], 64))
}